import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="py-24 px-6 max-w-2xl mx-auto text-center" data-testid="checkout-cancel-page">
      <XCircle size={64} className="mx-auto text-[#8B0000]" />
      <h1 className="font-serif text-4xl mt-6">Checkout Cancelled</h1>
      <p className="mt-4 text-white/70 text-lg">No charge was made. You can try again whenever you're ready.</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/shop" className="bg-[#8B0000] hover:bg-[#A50000] text-white px-8 py-3 text-xs uppercase tracking-[0.2em]">Back to Shop</Link>
        <Link to="/" className="border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-8 py-3 text-xs uppercase tracking-[0.2em]">Home</Link>
      </div>
    </div>
  );
}
